import { render, staticRenderFns } from "./SendMessagePreviewModal.vue?vue&type=template&id=56c8817b&lang=pug"
import script from "./SendMessagePreviewModal.vue?vue&type=script&lang=ts"
export * from "./SendMessagePreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports